const DeviceTypes = {
  DESKTOP: "DESKTOP",
  MOBILE: "MOBILE"
};
module.exports = {
  DeviceTypes
};
